module.exports = __webpack_public_path__ + "img/IT0000106722850.8b6c9102.png";